import { useEffect, useCallback } from 'react';

import useBreakpoints from '@zenbusiness/zui/useBreakpoints';
import PropTypes from 'prop-types';

import useSkeleton from '#client/hooks/useSkeleton';
import useToastContext from '#client/hooks/useToastContext';

import { CloseButtonStyled, DialogStyled, DialogTitleStyled } from './FormModal.styles';

export default function FormModal({
  children,
  handleClose,
  hasCloseIcon = true,
  TransitionComponent,
  titlesize,
  fullScreen = true
}) {
  /**
   * Show null when init modal
   */
  const [isShowNull] = useSkeleton(true);
  const { clearAllToast } = useToastContext();

  const {
    sizes: { isMobile }
  } = useBreakpoints();

  useEffect(() => {
    clearAllToast();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClearToastAndClose = useCallback(() => {
    clearAllToast();
    handleClose();
  }, [clearAllToast, handleClose]);

  return (
    <DialogStyled
      disableRestoreFocus
      fullScreen={fullScreen}
      onClose={handleClose}
      open
      TransitionComponent={TransitionComponent}
    >
      <DialogTitleStyled
        component="div"
        titlesize={titlesize || (isMobile ? 'small' : 'normal')}
      >
        {handleClose && hasCloseIcon && (
          <CloseButtonStyled
            iconSrc="/icon/micro/close-x.svg"
            label="Close form modal"
            onClick={handleClearToastAndClose}
            size="sm"
            titlesize={titlesize}
          />
        )}
      </DialogTitleStyled>
      {isShowNull ? null : children}
    </DialogStyled>
  );
}

FormModal.propTypes = {
  children: PropTypes.node.isRequired,
  handleClose: PropTypes.func,
  hasCloseIcon: PropTypes.bool,
  titlesize: PropTypes.oneOf(['small', 'normal']),
  TransitionComponent: PropTypes.elementType,
  fullScreen: PropTypes.bool
};
